var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-header",
        {
          ref: "header",
          staticClass: "header",
          staticStyle: { height: "auto", "margin-bottom": "10px" },
        },
        [
          _c(
            "el-form",
            {
              ref: "searchFormRef",
              staticClass: "demo-form-inline",
              attrs: { inline: true, model: _vm.searchForm },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "", prop: "company" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入公司名称" },
                    nativeOn: {
                      keydown: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.handleSearchBtn.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.searchForm.company,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "company", $$v)
                      },
                      expression: "searchForm.company",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "small",
                        icon: "el-icon-search",
                      },
                      on: { click: _vm.handleSearchBtn },
                    },
                    [_vm._v("搜索")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticClass: "bearing-table",
          attrs: {
            border: "",
            data: _vm.data,
            "highlight-current-row": "",
            "max-height": 500,
          },
          on: { "row-click": _vm.handleRowClick },
        },
        [
          _c("el-table-column", { attrs: { prop: "cid", label: "CID" } }),
          _c("el-table-column", {
            attrs: { prop: "classname", label: "客户类别" },
          }),
          _c("el-table-column", {
            attrs: { prop: "company", label: "公司名称" },
          }),
        ],
        1
      ),
      _c("el-pagination", {
        staticStyle: { "margin-top": "14px", "margin-bottom": "14px" },
        attrs: {
          "current-page": _vm.selectPage.pageNum,
          "page-sizes": [20, 50, 100, 200],
          "page-size": _vm.selectPage.pageSize,
          background: "",
          layout: "total, sizes, prev, pager, next, jumper",
          total: _vm.allNum,
        },
        on: {
          "size-change": _vm.pageSizeChange,
          "current-change": _vm.pageCurrentChange,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }